"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CanvasIconTypes;
(function (CanvasIconTypes) {
    CanvasIconTypes["Accent"] = "accent";
    CanvasIconTypes["Applet"] = "applet";
    CanvasIconTypes["System"] = "system";
    CanvasIconTypes["Graphic"] = "graphic";
})(CanvasIconTypes = exports.CanvasIconTypes || (exports.CanvasIconTypes = {}));
